export default (context) => {
    context.commit('setArchived', true);
    context.dispatch('saveState');
    context.dispatch('getData')
}


// WEBPACK FOOTER //
// ./src/app/store/base/actions/show-archived.js